import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { formatCurrency } from '@angular/common';

import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { BuyerPurchaseService } from '../../comprar.service';
import { NotificationService } from 'app/_services/notification.service';
import { UserService } from 'app/_services/user.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { BuyPostModel, RespostaCompraPost } from '../../_models/buyPostModel';
import { CheckoutAnswer, CheckoutAnswerPart } from '../../_models/purchaseAreaResponses';
import { CheckoutModalResponseEnum } from '../../_models/modalEnum';
import { MixPanelService } from 'app/_services/mix-panel.service';
import { Globals } from 'app/_models/globals';
import { MixPanelEventEnum } from 'app/_models/mixPanelEventEnum';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { TipoCalculoTotalEnum } from '../../_models/tipoCalculoTotalEnum';
import { AccountService } from 'app/account/account.service';
import { TranslateService } from '@ngx-translate/core';

declare const $: any;
declare const addTooltip: any;

@Component({
    selector: 'app-checkout-modal', templateUrl: 'checkout-modal.component.html', styleUrls: ['checkout-modal.component.scss'],
    standalone: false
})
export class BuyerComprarCheckoutModalComponent implements OnInit {
    public answerHasCashback: boolean = false;
    public listas: any = { cnpjs: [] };
    public quotationId: number = 0;

    public chosenAnswers: CheckoutAnswer[] = [];
    public selectedChosenAnswers: CheckoutAnswer[] = [];

    @Input() visivel: boolean;
    @Output() fechar = new EventEmitter<any>();
    @Output() limparCache = new EventEmitter<any>();
    @ViewChild('templateModalCompra') templateCompra: TemplateRef<any>;

    com_complemento_fiscal: number = 0;
    modalRef: BsModalRef;
    taxa_cashback_partsfy: number;
    temPecaPF: boolean = false;
    valorTotalPedidos: number;
    valorTotalCashback: number;

    constructor(public userService: UserService,
        public accountService: AccountService,
        private buyerVisaoGeralComprarService: BuyerPurchaseService,
        private mixPanelService: MixPanelService,
        private notificationService: NotificationService,
        private globals: Globals,
        private modalService: BsModalService,
        private ngxLoader: NgxUiLoaderService,
        private translate: TranslateService)
    {
        this.taxa_cashback_partsfy = 40;
        this.listas = { cnpjs: [] };
    }

    ngOnInit(): void { }

    alinharDesconto(answer: CheckoutAnswer, somenteSelecionadas: boolean) {
        const answerParts: CheckoutAnswerPart[] = answer.parts;
        const selectedParts = somenteSelecionadas ? answerParts.filter(p => p.isChosen) : answerParts;

        const firstDiscount = selectedParts[0].discount;

        if (somenteSelecionadas)
            selectedParts.map(p => { p.discount = firstDiscount; this.checkPecaDiscount_blur(answer, p); });
        else
            selectedParts.map(p => p.discount = firstDiscount);
    }

    checkPecaDiscount_blur(answer: CheckoutAnswer, part: CheckoutAnswerPart) {
        if (!part.discount || part.discount < 0)
            part.discount = 0;

        if (part.discount > part.discountOriginal)
            part.discount = part.discountOriginal;

        this.setOrderValuePerAnswer(answer);
        this.setTotalOrderValue();
    }

    checkTaxaPartsfy_blur() {
        if (this.taxa_cashback_partsfy < 25 || this.taxa_cashback_partsfy > 40)
            this.taxa_cashback_partsfy = 40;

        this.chosenAnswers.forEach(answer => this.setOrderValuePerAnswer(answer));
        this.setTotalOrderValue();
    }

    closeModal(status: CheckoutModalResponseEnum) {
        this.modalRef.hide();
        this.fechar.emit(status);
    }

    async finalizarCompra() {
        if (!this.userService.userIsCentral())
            this.com_complemento_fiscal = 1;

        // Valida se selecionou o complemento fiscal
        if (this.com_complemento_fiscal <= 0) {
            await this.notificationService.showWarning('', 'buyer.cotacao.area-comprar.modal-confirmar-compra.complemento-fiscal.alert');
            return;
        }

        const cnpjFaturamento = $('select[name="cnpjFaturamento"]').val();
        const respostasComPecasSelecionadas = this.selectedChosenAnswers;
        let respostas = [];

        $.each(this.chosenAnswers, function (i: any, resposta: CheckoutAnswer) {
            const pSs = resposta.parts.filter(x => x.isChosen);
            const tipoSelecionado = $('.resposta_' + resposta.answerId).val();

            let respostaVendedor: RespostaCompraPost = {
                seller_company_id: resposta.sellerCompanyId,
                selected_payment_type: parseInt(tipoSelecionado),
                shipping_cost: resposta.selectedShippingCost,
                parts: []
            };

            $.each(pSs, function (j: any, peca: CheckoutAnswerPart) {
                respostaVendedor.parts.push({
                        item_id: peca.itemId,
                        discount: peca.discount,
                        selected_quantity: peca.selectedQuantity,
                    });
            });

            respostas.push(respostaVendedor);
        });

        const listaDatasEntregaPorResposta = respostasComPecasSelecionadas.map(r => ({ id: r.answerId, itens: r.parts.filter(i => i.isChosen).map(i => i.deliveryTimeDay) }));
        const existemDatasDiferentesMesmoVendedor = listaDatasEntregaPorResposta.some(d => [... new Set(d.itens)].length > 1 && d.itens.length > 1);

        if (existemDatasDiferentesMesmoVendedor)
        {
            const params: SweetAlertParams = {
                title: 'buyer.cotacao.area-comprar.modal-confirmar-compra.confirm.alterar-datas',
                cancelButtonText: 'buyer.cotacao.area-comprar.modal-confirmar-compra.botao.manter',
                confirmButtonText: 'buyer.cotacao.area-comprar.modal-confirmar-compra.botao.trocar'
            }

            this.notificationService.showConfirm(params).then((result) => {
                var padronizarDataEntrega = (result.isConfirmed);

                if (result.isDismissed && result.dismiss.toString() !== 'cancel')
                    return;

                this.finalizarCompraExecucao(this.quotationId, cnpjFaturamento, padronizarDataEntrega, respostas);
            });
        }
        else
            this.finalizarCompraExecucao(this.quotationId, cnpjFaturamento, false, respostas);
    }

    private finalizarCompraExecucao(quotation_id: number, cnpj_faturamento: any, change_delivery_date: boolean, answers: RespostaCompraPost[]) {
        this.ngxLoader.startLoader('loader-compra');
        let is_custo_fiscal = this.com_complemento_fiscal == 1;
        let taxa_cashback_partsfy = this.taxa_cashback_partsfy;
        let company_id = this.userService.companyId();

        let body: BuyPostModel = {
            quotation_id,
            is_custo_fiscal,
            cnpj_faturamento,
            taxa_cashback_partsfy,
            change_delivery_date,
            company_id,
            answers
        };

        this.buyerVisaoGeralComprarService.buy(body).subscribe({
            next: async (response: ApiResponseModel<boolean>) => {
                if (response && response.success) {
                    // Limpa o cache das peças salvas antes da compra
                    this.limparCache.emit();

                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.mensagens.comprar.sucesso.corpo'));
                    this.ngxLoader.stopLoader('loader-compra');
                    this.updateMixPanelInfo();

                    if (response.result)
                        this.closeModal(CheckoutModalResponseEnum.voltarVisaoGeral);
                    else
                        this.closeModal(CheckoutModalResponseEnum.listarRespostas);
                }
                else {
                    await this.notificationService.showWarning('buyer.cotacao.mensagens.erro.corpo', 'buyer.cotacao.mensagens.erro.titulo');
                    this.ngxLoader.stopLoader('loader-compra');
                }
            },
            error: async (error) => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-compra');
                
                if (error.status == 200) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.mensagens.comprar.sucesso.corpo'));
                    this.closeModal(CheckoutModalResponseEnum.voltarVisaoGeral);
                }
                else if (error.status == 404){
                    this.closeModal(CheckoutModalResponseEnum.voltarVisaoGeral);
                    this.translate.get('buyer.cotacao.mensagens.listar.erro.nao-encontrada').subscribe(corpo => {
                        this.notificationService.showErrorToastr(corpo.replace("#xxx", "#" + quotation_id));
                    });
                } else {
                    this.closeModal(CheckoutModalResponseEnum.somenteFechar);
                    await this.notificationService.showWarning('buyer.cotacao.mensagens.erro.corpo', 'buyer.cotacao.mensagens.erro.titulo');
                }
            }
        });
    }

    getTotalCashback(resposta: CheckoutAnswer) {
        const itens = resposta.parts;
        const imposto_fornecedor = (resposta.tax && resposta.tax > 0 ? resposta.tax : 0);
        // const margem_fornecedor = (resposta.cashback_profit_margin && resposta.cashback_profit_margin > 0 ? resposta.cashback_profit_margin : 0);
        const margem_fornecedor = 0;
        const margem_partsfy = this.taxa_cashback_partsfy;
        let oficina = 0;
        let partsfy_share = 0;
        let supplier_share = 0;

        for (let i = 0; i <= itens.length - 1; i++) {
            const item = itens[i];

            if (item.isChosen) {
                const original = (item.selectedQuantity * item.price * (100 - item.discountOriginal) / 100);
                const escolhido = (item.selectedQuantity * item.price * (100 - item.discount) / 100);

                const diferenca = (escolhido - original);
                const diferenca_sem_imposto = diferenca - (diferenca * imposto_fornecedor / 100);

                const cashback_total = parseFloat(diferenca_sem_imposto.toFixed(2));
                const cashback_final = parseFloat((cashback_total * (1 - (margem_partsfy / 100))).toFixed(2));
                const cashback_comprador = parseFloat((cashback_final * (1 - (margem_fornecedor / 100))).toFixed(2));

                partsfy_share += parseFloat((cashback_total - cashback_final).toFixed(2));
                supplier_share += parseFloat((cashback_final - cashback_comprador).toFixed(2));
                oficina += cashback_comprador > 0 ? cashback_comprador : 0;
            }
        }

        return { total: oficina + partsfy_share + supplier_share, oficina: oficina, partsfy_share: margem_partsfy, supplier_share: margem_fornecedor };
    }

    inicializar() {
        // Reinicia os descontos -> seta para valor original e verifica se tem alguma peça PF
        let hasPF: boolean = false;
        this.chosenAnswers.forEach(answer => {
            answer.parts.forEach(part => {
                part.discount = part.discountOriginal;

                if (part.isChosen && part.isPF)
                    hasPF = true;
            });

            this.setOrderValuePerAnswer(answer);
        });

        this.setTotalOrderValue(); // Atualiza os totais
        this.com_complemento_fiscal = 0;

        this.openModal();
        setTimeout(() => addTooltip(), 200);
    }

    private openModal() {
        let options: ModalOptions = { backdrop: 'static', class: 'checkout-modal gray', keyboard: false };
        this.modalRef = this.modalService.show(this.templateCompra, options);

        if ($('select[name="cnpjFaturamento"]').length > 0)
            $('select[name="cnpjFaturamento"]')[0].selectedIndex = "0";

        $('select[class*="resposta_"]').each(function (i: any, resposta: { selectedIndex: string; }) { resposta.selectedIndex = "0"; });
    }

    setOrderValuePerAnswer(answer: CheckoutAnswer) {
        const totalOriginal = this.buyerVisaoGeralComprarService.getOrderValueFromAnswer(answer, TipoCalculoTotalEnum.TotalOriginal);
        const totalEscolhido = this.buyerVisaoGeralComprarService.getOrderValueFromAnswer(answer, TipoCalculoTotalEnum.TotalEscolhido);
        const totalCashback = this.getTotalCashback(answer).oficina;

        const rebate = (totalEscolhido.totalPecas * (answer.rebate / 100)) * answer.rebatePartsfy; // desconta os impostos

        answer.totalOriginal = totalOriginal.total;
        answer.totalOriginalFormatted = formatCurrency(totalOriginal.total, 'pt-BR', 'R$', 'BRL');
        answer.totalChosen = totalEscolhido.total;
        answer.totalChosenFormatted = formatCurrency(totalEscolhido.total, 'pt-BR', 'R$', 'BRL');
        answer.totalCashback = totalCashback > 0 ? totalCashback : rebate;

        answer.class = answer.totalCashback > 0 ? 'd-none' : '';
        answer.classCashback = answer.totalCashback > 0 ? '' : 'd-none';
    }

    setTotalOrderValue() {
        const totalCashback = this.chosenAnswers.reduce((acc, r) => acc + r.totalCashback, 0);
        this.valorTotalCashback = totalCashback;

        const totalPedidos = this.chosenAnswers.reduce((acc, r) => acc + r.totalChosen, 0);
        this.valorTotalPedidos = totalPedidos;
    }

    private updateMixPanelInfo() {
        let user = this.userService.user();
        this.mixPanelService.updateUserPropertiesMixPanel(user).subscribe({ error: (e: any) => console.error(e) });
        this.mixPanelService.trackMixPanelEvent(MixPanelEventEnum.Buy).subscribe({ error: (e: any) => console.error(e) });
        this.mixPanelService.incrementUserPropertiesMixPanel({ "Transactions": 1 }).subscribe({ error: (e: any) => console.error(e) });
    }

    get CheckoutModalResponseEnum(): typeof CheckoutModalResponseEnum {
        return CheckoutModalResponseEnum;
    }
}
